(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search-by-vehicle"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {
  const ariaMap = {
    mk: 'Make',
    md: 'Model',
    yr: 'Year'
  };

  function addAriaLabel(select) {
    const label = ariaMap[select.className];
    if (label && !select.hasAttribute('aria-label')) {
      select.setAttribute('aria-label', label);
    }
  }

  function processSelects() {
    let allDone = true;
    Object.keys(ariaMap).forEach(cls => {
      const selects = document.querySelectorAll(`select.${cls}`);
      if (selects.length === 0) {
        allDone = false;
      } else {
        selects.forEach(addAriaLabel);
      }
    });
    return allDone;
  }

  const interval = setInterval(() => {
    if (processSelects()) {
      clearInterval(interval);
      console.log('All aria-labels added, polling stopped.');
    }
  }, 200);
});


  } catch(e) { console.error(e); }
})();
})();
